var styles = {"container":"Newsletters-module_container__Wtb8L","label":"Newsletters-module_label__WPAsU"};

export { styles as default };
//# sourceMappingURL=Newsletters.module.scss.js.map
